import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';
import { Helmet } from 'react-helmet';
import styled from '@emotion/styled';
import Card from 'components/Card';
import { 
  ButtonGroup, Button, NonIdealState, Spinner
} from "@blueprintjs/core";
import ProductCategoryTable from 'components/Tables/ProductCategory';
import SettingsSidebar from '../preferences/settings-sidebar';
import ProductCategory from 'components/ProductCategory/ProductCategory';

const CardHolder = styled('div')`
  padding: ${props => `${props.theme.unit*3}px`};
`
const PageWrapGray = styled('div')`
  padding: 12px;
  background-color: #F8FAFB;
  min-height: calc(100vh - 75px);
`

@inject('store', 'productCategoryStore',) @observer
class ProductCategoryIndexPage extends Component {

  @observable isProductCategoryDialogVisible = false;

  componentDidMount() {
    let { productCategoryStore } = this.props;
    productCategoryStore.loadProductCategories()
  }

  get canRender() {
    let {
      productCategoryStore: {
        productCategories: {
          isLoading,
          isError,
          objects
        }
      }
    } = this.props;
    return (!isLoading && !isError && objects);
  }

  onCloseProductCategoryDialog() {
    this.isProductCategoryDialogVisible = false;
  }

  onSucessCreateProductCategory(productService) {
    this.isProductCategoryDialogVisible = false;
  }

  render() {
    let content;
    let {
      productCategoryStore: {
        productCategories: {
          isLoading,
          isError
        }
      }
    } = this.props;
    if (isLoading && !isError) {
      content = <CardHolder><Spinner/></CardHolder>;
    }
    if (isError && !isLoading) {
      content = <NonIdealState title="Failed" description="Sorry, something went wrong" />;
    }
    if (this.canRender) {
      content = <ProductCategoryTable />;
    }
    return(
      <div className="taxed-page-layout">
        <Helmet>
          <title>Products Category | FieldNexus</title>
        </Helmet>
        <div className="row no-gutters">
          <div className="col-lg-2 sidebar-responsive">
            <SettingsSidebar />
          </div>
          <div className="col-lg-10">
            <PageWrapGray>
              <Card>
                <div>            
                  <div className="text-right mb-2">
                    <ButtonGroup>
                      <Button icon='add' onClick={() => this.isProductCategoryDialogVisible = true }>
                        Add
                      </Button>
                    </ButtonGroup>
                  </div>
                </div>
                {content}
              </Card>
            </PageWrapGray>
          </div>
        </div>
        <ProductCategory 
          isOpen={this.isProductCategoryDialogVisible} 
          title={"Add Product Category"}
          edit={false}
          onClose={this.onCloseProductCategoryDialog.bind(this)}
          onSuccess={this.onSucessCreateProductCategory.bind(this)}
        />
      </div>
    )
  }

}

export default ProductCategoryIndexPage;